// Copyright (c) Frisbii GmbH. All rights reserved.
'use strict';

var ContractRevenueWriteOffController = function ($scope, $modal, $rootScope, $routeParams, $location, $http, Contract,
    ProductInfo, AccountingExportSettings, SharedParameters, RevenueWriteOffHelper, gettextCatalog, gettext, DatepickerUtils,
    PUtill) {

    $scope.applyClicked = false;

    var productInfo = ProductInfo.get(function () {
        $scope.contract = Contract.get({contractId: $routeParams.contractId}, function () {
            $scope.plan = productInfo.PlanById($scope.contract.PlanId);
        });
    });

    function setDatePickerRange() {
        AccountingExportSettings.get({},
            function (accountingSettings) {
                $scope.bookingDateConstraints = RevenueWriteOffHelper.getBookingDateConstraints(accountingSettings.FinalizedDate);
            });
    }
    
    setDatePickerRange();
    
    $scope.$watch('localDate',function(){
        $scope.applyClicked = false;
    });

    $scope.writeOff = function () {
        if ($scope.applyClicked)
            return;
        
        $scope.applyClicked = true;
        let bookingDateString = DatepickerUtils.toShortBerlinDateString($scope.bookingDateConstraints.bookingDate);

        $http({
            method: "POST", url: "/api/v1/contracts/" + $routeParams.contractId + "/writeOff", params: null,
            data: { BookingDate: bookingDateString }, headers: { }, cache: false
        }).then(function () {
            let message = gettextCatalog.getString(gettext("Contract was successfully written off"));
            SharedParameters.setValue('NotifyContract', { messageType: 'success', message: message });
            $location.path("/contracts/" + $routeParams.contractId);
        });
    }
};

ContractRevenueWriteOffController.$inject = ['$scope', '$uibModal', '$rootScope', '$routeParams', '$location', '$http',
    'Contract', 'ProductInfo', 'AccountingExportSettings', 'SharedParameters', 'RevenueWriteOffHelper', 'gettextCatalog',
    'gettext', 'DatepickerUtils', 'PUtill'];
